export const FIND_PAYMENT_BY_ID = 'FIND_PAYMENT_BY_ID';
export const FIND_PAYMENT_BY_ID_REQUEST = 'FIND_PAYMENT_BY_ID_REQUEST';

export const REFUND_PAYMENT = 'REFUND_PAYMENT';
export const REFUND_PAYMENT_REQUEST = 'REFUND_PAYMENT_REQUEST';
